import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { PortalModule } from '@angular/cdk/portal';
import { UserComponent } from './user.component';
import { UserMenuItemDirective } from './user-menu-item.directive';
import { LazyImageModule } from '@redoc-starter/redoc';

@NgModule({
  declarations: [UserComponent, UserMenuItemDirective],
  imports: [CommonModule, MatButtonModule, MatDividerModule, MatIconModule, MatMenuModule, PortalModule, LazyImageModule],
  exports: [UserComponent, UserMenuItemDirective],
})
export class UserModule { }
